import React, { FC, useEffect, useMemo, useState } from 'react';
import './styles.scss';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as SurgeIcon } from '../../../assets/icons/update-surge-modal-icon.svg';
import { ORDER_SURGE_MINUTES } from 'utils/constants';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

interface SurgeModalProps {
  show: boolean;
  loading?: boolean;
  order: OrderType;
  onClose: () => void;
}

const KitchenSurgeModal: FC<SurgeModalProps> = ({ show, loading, order, onClose }) => {
  const [title, setTitle] = useState('Manage General surge');
  const [activeSurge, setActiveSurge] = useState<number>(0);
  const [removeSurge, setRemoveSurge] = useState<boolean>(false);
  const [disableCheckbox, setDisableCheckbox] = useState<boolean>(false);

  const orderCode = useMemo(() => {
    return order.order_code ?? '';
  }, [order]);

  useEffect(() => {
    if (orderCode !== '') setTitle(`Add Surge to #${orderCode.toUpperCase()}`);
    const value = order?.surge?.kitchen_surge_estimated_time ?? 0;

    if (+value === 0) {
      setDisableCheckbox(true);
    } else {
      setDisableCheckbox(false);
      setActiveSurge(+value);
    }
  }, [show]);

  const emitValue = (): void => {
    const val = removeSurge ? 0 : activeSurge;
    updateDeliveryFactors(val);
  };

  const selectMinute = (minute: number): void => {
    setRemoveSurge(false);
    setActiveSurge(minute);
  };

  const updateDeliveryFactors = async (surge: number) => {
    const data = {
      kitchen_surge: surge === 0 ? 0.0 : 1.0,
      kitchen_surge_estimated_time: `${surge}`,
      order_id: order?.id
    };
    try {
      const message = order?.id + ' surge updated successfully!';
      await apiService.post('marketing/surge', {
        data,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(<ToastMessage type='success' message={message} />);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      onClose();
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title={title}
      description='Increase estimated time for orders in kitchen'
      titleIcon={<SurgeIcon />}
      titleIconColor='info'
      onRequestClose={onClose}
      footer={
        <Button
          color='primary'
          variant='block'
          className='mx-auto'
          loading={loading}
          onClick={emitValue}>
          Confirm
        </Button>
      }>
      <div className='grid grid-cols-3 gap-8 max-w-[420px]'>
        {ORDER_SURGE_MINUTES.map((minute: any) => (
          <span
            key={minute}
            className={`surge-modal__button ${
              activeSurge === minute && !removeSurge ? 'is-active' : ''
            }`}
            role='button'
            onClick={() => selectMinute(minute)}>
            {minute === 0 ? 'None' : `+ ${minute} mins`}
          </span>
        ))}
      </div>
      <div className='my-3'>
        <Input
          type='checkbox'
          label={`Remove${orderCode === '' ? ' general' : ''} surge`}
          onChange={() => setRemoveSurge(!removeSurge)}
          checked={removeSurge}
          disabled={disableCheckbox}
          inline
        />
      </div>
    </BaseModal>
  );
};

export default KitchenSurgeModal;
